<template>
  <div class="blog-post-header">
    <div class="header">
      <div id="header-content">
        <div class="left-header-content">
          <div id="post-titles">
            <h1 class="title is-size-2-desktop is-size-3-tablet is-size-3-mobile">{{ postTitle }}</h1>
            <h2 v-if="postSubtitle" class="subtitle is-size-3-desktop is-size-4-tablet is-size-5-mobile">
              {{ postSubtitle }}
            </h2>
          </div>
          <BlogPostMetaDetails
            :author-first-name="authorFirstName"
            :author-last-name="authorLastName"
            :date="postDate"
          />
        </div>
      </div>
      <div class="feature-image-container column">
        <img class="feature-image" :src="imageUrl" :alt="$t('blog.articleImage')" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostHeader",
  props: {
    postTitle: {
      type: String,
      required: true,
    },

    postSubtitle: {
      type: String,
      default: "",
    },

    authorFirstName: {
      type: String,
      required: true,
    },

    authorLastName: {
      type: String,
      required: true,
    },

    postDate: {
      type: String,
      required: true,
    },

    imageUrl: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
//@import "/scss/variables";

.header {
  width: 100%;
  background: linear-gradient(135deg, #3e2461 36%, rgba(62, 36, 97, 0.64) 100%);
  color: white;
  min-height: 360px;
  display: flex;
  padding: 0 0 0 10%;
  justify-content: center;
  align-items: stretch;

  .left-header-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
  }

  .left-header-content {
    padding: 2rem 2rem 4rem 0;
  }

  .title,
  .subtitle {
    color: white;
  }

  .title {
    font-weight: 500;
  }

  .subtitle {
    font-weight: lighter;
    padding-top: 8px;
  }

  #post-titles {
    max-width: 800px;
    color: white;
  }

  .feature-image-container {
    display: flex;
    justify-content: flex-end;
    max-height: 500px;
    margin: 0;
    padding: 0;
  }

  .feature-image {
    border-radius: 0;
    max-width: 40vw;
    max-height: 100%;
    object-fit: cover;

    @media (max-width: $mobile) {
      display: none;
    }
  }

  @media (max-width: 1280px) {
    padding: 0 0 0 80px;
  }

  @media (max-width: $desktop) {
    padding: 0 0 0 40px;
  }

  @media (max-width: $tablet) {
    padding: 0 0 0 2%;
    min-height: unset;

    .left-header-content {
      padding: 20px;
    }
  }
}
</style>
